import { GetUserTransactionsQuery } from '../../../../graphql/api';
import { Transaction } from './types';

export const useGetUserTransactionsSelector = ({
  user,
}: GetUserTransactionsQuery): Transaction[] => {
  return user.transactions;
};
